function escapeCsvCell(value) {
  const normalized = value === null || value === undefined ? "" : String(value);
  return `"${normalized.replace(/"/g, '""')}"`;
}

export function exportRowsToCsv(filename, headers, rows) {
  const separator = ";";
  const content = [headers, ...rows]
    .map((row) => row.map((cell) => escapeCsvCell(cell)).join(separator))
    .join("\r\n");

  const blob = new Blob(["\ufeff" + content], {
    type: "text/csv;charset=utf-8;",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
